module.exports = __webpack_public_path__ + "static/img/Store-16.c3787db6.png";